var React = require('react');

function IconBrandie (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M149.74,216.23C135,234.75,108.16,243.07,90,237c-14.75,14.36-33.27,22.68-49.9,22.68-21.93,0-41.21-15.12-40.07-51C3.07,121.34,65.07,0,89.26,0c3,0,9.45,3,16.26,7.94,4.91,3.78,7.93,7.18,4.91,9.83C75.27,50.28,37.47,138,27.64,184.85c-4.53,22.31-4.53,58.6,26.84,57.08,7.56-.37,15.5-4.16,22.31-11.34C26.51,213.2,23.48,147.43,70,135.71a26.1,26.1,0,0,1,7.56-1.13c19.28,0,39.32,17.38,39.32,42,0,12.85-4.16,31.37-13.23,44.6,12.85,5.29,28.72-3.78,37.42-14a9.19,9.19,0,0,1,6.8-3.41C154.28,203.75,152.77,212.45,149.74,216.23ZM63.56,195.44c3.78,9.45,14.36,15.5,23,20C111.19,153.85,44.28,147.05,63.56,195.44Z"}));
}

IconBrandie.defaultProps = {"viewBox":"0 0 152.34 259.7"};

module.exports = IconBrandie;

IconBrandie.default = IconBrandie;
